import { z } from 'zod';

export const customerSubscriptionSchema = z.object({
  subscriber: z.boolean(),
  documentId: z.nullable(z.string()),
  isOnboardingCompleted: z.boolean(),
  profilePicture: z.nullable(z.string()),
  displayName: z.nullable(z.string()),
});

export type CustomerSubscription = z.infer<typeof customerSubscriptionSchema>;
